
import ProductVideoPreview from '@/components/ProductVideoPreview.vue'

export default {
  name: 'CustomerMediaTeaser',
  components: { ProductVideoPreview },
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  computed: {
    videos() {
      return this.media.videos || []
    },
    images() {
      return this.media.images || []
    },
    firstVideo() {
      return this.videos[0] || null
    },
    firstImage() {
      return this.images[0] || null
    },
    thumbs() {
      const pool = this.firstVideo ? this.images : this.images.slice(1)
      return pool.slice(0, 3)
    },
    counts() {
      const videos = this.media.videos_count ?? this.videos.length
      const photos = this.media.images_count ?? this.images.length
      return [
        videos &&
          this.$tc('components.viewerImages.customerVideos', videos, {
            count: videos,
          }),
        photos &&
          this.$tc('components.viewerImages.customerPhotos', photos, {
            count: photos,
          }),
      ]
        .filter(Boolean)
        .join(' · ')
    },
  },
}
